module.exports = __webpack_public_path__ + "static/media/walk_step.9799de12.png";